import moment from 'moment/moment'

import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { CacheFactory } from './CacheFactory'
import { Industry } from './Industry'
import { FKType } from './SQLBuilder'

type ChannelConstructorArgs = Omit<ConstructorArgs<() => Channel>, 'collect_referrer'> & {
    collect_referer: boolean | null
}

export class Channel extends BaseRecord {
    readonly recordType = 'channel'

    name?: string
    url?: string
    leadSource?: boolean
    collectReferrer?: boolean
    onboarding?: number // Integer
    lastModifiedDate?: moment.Moment

    constructor(data?: Partial<ChannelConstructorArgs>, params?: { id?: string }) {
        super(data)
        if (!data) {
            this.id = params?.id
            return
        }

        this.name = data.name ?? undefined
        this.url = data.url ?? undefined
        this.leadSource = data.lead_source ?? false
        this.collectReferrer = data.collect_referer ?? false
        this.onboarding = this.propertyFromIntArg(data.onboarding)
        this.lastModifiedDate = this.propertyFromTimestampArg(data.last_modified_date)
    }

    clone(overrides?: Partial<ChannelConstructorArgs>): Channel {
        return new Channel({
            ...this.serializeForClone(),
            collect_referer: this.collectReferrer,
            ...overrides,
        })
    }

    static initWithId(id: string): Channel {
        const channel =
            CacheFactory.getInstance().getRecord(Channel, id) ?? new Channel(undefined, { id })
        return channel
    }

    deserialize(data: any) {
        super.deserialize(data)

        if (data.industry) this.industry = BaseRecord.fromSerializer(data.industry, Industry)
        if (data.lastModifiedDate) this.lastModifiedDate = moment(data.lastModifiedDate)
    }

    static fk: FKType = {}

    static dataType(): DataType {
        return 'channels'
    }

    get industry(): Industry | undefined {
        return this.getForeignRecord('industry', Industry)
    }
    set industry(industry: Industry | undefined) {
        this.setForeignRecord('industry', industry)
    }
}
